import {
  CHAT_WIDGET_INTAKE_FORM_SHOWN,
  CHAT_WIDGET_INTAKE_FIELD_COMPLETED,
  CHAT_WIDGET_INTAKE_COUNTRY_CODE_CHANGED,
  CHAT_WIDGET_INTAKE_VALIDATION_ERROR,
  CHAT_WIDGET_INTAKE_FORM_SUBMITTED,
  CHAT_WIDGET_INTAKE_FORM_ABANDONED,
  CHAT_WIDGET_INTAKE_NO_LAST_NAME_DECLARED,
} from '@/lib/analytics-events';

export {
  CHAT_WIDGET_INTAKE_FORM_SHOWN,
  CHAT_WIDGET_INTAKE_FIELD_COMPLETED,
  CHAT_WIDGET_INTAKE_COUNTRY_CODE_CHANGED,
  CHAT_WIDGET_INTAKE_VALIDATION_ERROR,
  CHAT_WIDGET_INTAKE_FORM_SUBMITTED,
  CHAT_WIDGET_INTAKE_FORM_ABANDONED,
  CHAT_WIDGET_INTAKE_NO_LAST_NAME_DECLARED,
};

export const INTAKE_FIELDS_REQUIRED = [
  'givenName',
  'familyName',
  'email',
  'phoneCountryIso',
  'phone',
  'currentCountryCode',
] as const;

/** Id of the intro sentence: the Skip link and focus-on-open move focus here. */
export const INTAKE_INTRO_ID = 'chat-intake-intro';

/** Intro under the agent name; `{institution}` is replaced at render time. */
export const INTAKE_INTRO_TEMPLATE =
  'Just a few details so {institution} can get back to you with the right information.';

/** `{institution}` is replaced at render time. */
export const INTAKE_CONSENT_TEMPLATE =
  'Do you consent to receiving communications regarding updates, services, and higher education opportunities with {institution}?';

export const INTAKE_CONSENT_OPTIONAL = 'Optional — you can chat either way.';

export const INTAKE_LOCKED_COMPOSER_TEXT =
  'Complete the form above to start chatting.';

export const INTAKE_NO_FAMILY_NAME_LABEL = "I don't have a last name";

/** Mirrors the backend family-name column limit. */
export const INTAKE_FAMILY_NAME_MAX_LENGTH = 100;

/** Mirror the API intake-lead schema (`intake-lead/types.ts`). */
export const INTAKE_GIVEN_NAME_MAX_LENGTH = 255;
export const INTAKE_EMAIL_MAX_LENGTH = 255;

export const INTAKE_PLACEHOLDERS = {
  givenName: 'Maria',
  familyName: 'Silva',
  email: 'you@example.com',
  dialCode: 'Code',
  phone: '415 555 2671',
  country: 'Select your country',
} as const;

/** Shared outlined-input surface for intake text fields. */
export const intakeFieldSx = {
  '& .MuiOutlinedInput-root': {
    bgcolor: 'background.paper',
    borderRadius: 1,
  },
};

/** Shared uppercase field label styles (mockup: small grey caps above inputs). */
export const intakeFieldLabelSx = {
  textTransform: 'uppercase' as const,
  fontSize: 11,
  letterSpacing: '0.04em',
  color: 'text.secondary',
  mb: 0.5,
  lineHeight: 1.2,
  '&.Mui-focused': { color: 'text.secondary' },
  '&.Mui-error': { color: 'error.main' },
};
